<template>
    <div class="faq-menu">
<!--        <div v-if="$mq === 'tablet' || $mq === 'desktop'" v-for="el in result.items" class="faq-menu-desktop">-->
<!--            <a :href="el.detailPage" class="faq-menu-desktop__item">{{ el.name }}</a>-->
<!--&lt;!&ndash;            <a href="/faq/cctv/" class="faq-menu-desktop__item faq-menu-desktop__item_active">non CCTV</a>&ndash;&gt;-->
<!--        </div>-->
        <div class="faq-menu-mobile" v-for="section in result.sections">
            <div class="faq-menu-mobile-header">
                {{ section.name }}
                <span class="faq-menu-mobile-header__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.04773 5.79844C6.34773 4.29844 7.64773 2.69844 8.84773 1.19844C9.44773 0.498437 8.54773 -0.401563 8.04773 0.198437C6.84773 1.59844 5.74773 2.99844 4.64773 4.29844C3.44773 2.99844 2.24773 1.59844 1.04773 0.198437C0.547729 -0.401563 -0.35227 0.498437 0.14773 1.09844C1.44773 2.69844 2.74773 4.19844 4.14773 5.79844C4.44773 6.09844 4.84773 6.09844 5.04773 5.79844Z" fill="#333333"/>
                    </svg>
                </span>
            </div>
            <div class="faq-menu-mobile-main-js">
                <div class="faq-menu-mobile-main" v-for="el in section.items">
                    <a :href="el.detailPage" target="_blank" class="faq-menu-mobile-main__item">{{ el.name }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FaqMenu',
    props: ['result'],
    data() {
        return {
            screenWidth: window.innerWidth,
        }
    },
    mounted() {
        $(document).on('click', '.faq-menu-mobile-header', function () {
            $(this).toggleClass('active')
            $(this).closest('.faq-menu-mobile').find('.faq-menu-mobile-main-js').slideToggle();
        });
    }
}
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .faq-menu{
    width: 80%
  }
}
.faq-menu{
    @include point-lg{
        justify-self: center;
    }
}
.faq-menu-desktop{
    display: grid;
    //grid-auto-rows: 50px;
    grid-auto-rows: 100px;
    border-radius: 8px;
    border: 1px solid var(--abv-black-7, #d9d9d9);
    border-bottom: unset;
    &__item{
        display: flex;
        align-items: center;
        padding: 15px;
        //font-size: 16px;
        font-size: 32px;
        font-style: normal;
        //font-weight: 600;
        line-height: 50px;
        color: var(--abv-main-black, #292929);
        text-decoration: unset;
        border-bottom: 1px solid #D9D9D9;
        transition: .2s linear background-color;
        &_active{
            background: #FFF3DF;
            border: 1px solid #F7A707;
            margin: -1px;
        }

        &:first-child{
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }
        &:last-child{
            border-bottom-right-radius: 8px;
            border-bottom-left-radius: 8px;
        }
    }
}

.faq-menu-mobile{
    //position: relative;
}
.faq-menu-mobile-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 14px;
    height: 44px;
    background: #FFF3DF;
    border-radius: 8px;
    font-size: 20px;
    border: 1px solid var(--abv-main-orange, #F7A707);
    &__icon{
        transition: .2s linear transform;
    }
    &.active{
        .faq-menu-mobile-header__icon{
            transform: rotate(180deg);
        }
    }
    @include point-lg{
      font-size: 60px;
      height: 80px;
      white-space: nowrap;
    }
}
.faq-menu-mobile-main-js{
    display: none;
}
.faq-menu-mobile-main{
    display: grid;
    grid-auto-rows: 44px;
    border: 1px solid #D9D9D9;
    background-color: #fff;
    cursor: pointer;
    border-radius: 8px;
    margin-top: 10px;


    color: var(--abv-main-black, #292929);
    //font-family: Proxima Nova;
    font-size: 16px;
    font-style: normal;
    //font-weight: 600;
    line-height: 44px; /* 275% */
    &__item{
        display: flex;
        align-items: center;
        padding: 0 15px;
        text-decoration: none;
        color: #292929;
        &:hover,
        &:visited{
            color: #292929;
        }
        &:not(:last-child){
            border-bottom: 1px solid #D9D9D9;
        }
    }
}
</style>